export default [
  {
    name: 'project_cover',
    component_path: 'modules/templates/blocks/project/ProjectCover'
  }
]